import React, { useState, useEffect, CSSProperties } from "react";

export interface LoaderProps {
  /** If true, renders as fixed full-screen overlay centered on viewport. */
  fullScreen?: boolean;
  /** If true, auto-hides after 3 seconds (used for initial layout boot). Default false. */
  initialOnly?: boolean;
  /** Minimum height when rendered inside a container (default: 200px). */
  height?: string | number;
  className?: string;
  style?: CSSProperties;
}

export default function Loader({
  fullScreen = false,
  initialOnly = false,
  height,
  className = "",
  style = {},
}: LoaderProps) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (initialOnly) {
      const timeout = setTimeout(() => {
        setShow(false);
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [initialOnly]);

  if (!show) return null;

  if (fullScreen) {
    return (
      <div className={`loader-wrapper ${className}`} style={style}>
        <div className="theme-loader">
          <div className="loader-p"></div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`theme-loader-container ${className}`}
      style={{ minHeight: height || "200px", ...style }}
    >
      <div className="theme-loader">
        <div className="loader-p"></div>
      </div>
    </div>
  );
}